import React from 'react';

const SlideArrows = ({ height = 32, width = 32, color = '#494949' }) => (
  <svg className="svg-icon" height={height} width={width} viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <title>split 33</title>
    <g fill={color}>
      <polygon fill={color} points="7,23 0,17 7,11 "/>
      <polygon fill={color} points="25,23 32,17 25,11 "/>
      <path d="M16,23c-3.309,0-6-2.691-6-6s2.691-6,6-6s6,2.691,6,6S19.309,23,16,23z"/>
    </g>
  </svg>
);

export default SlideArrows;
